/* eslint-disable */
<script>
/* eslint-disable */
import { API } from "../../api";
import Tree from "liquor-tree";

const api = new API();

export default {
  name: "DisplayTree",
  components: {
    Tree
  },

  props: ["json"],

  data() {
    return {
      treeData: {
        object: {
          a: "String",
          b: [1, 2, 3],
          c: 55,
          e: false
        },
        array: [1, 2, 3, -4, -3, -2],
        boolean: false,
        null: null,
        number: 21,
        string: "Hi liquor-tree user!"
      },
      treeOptions: {}
      // json: {
      //     "object": {
      //       "a": "String",
      //       "b": [
      //         1, 2, 3
      //       ],
      //       "c": 55,
      //       "e": false
      //     },
      //     "array": [
      //       1,
      //       2,
      //       3,
      //       -4,
      //       -3,
      //       -2
      //     ],
      //     "boolean": false,
      //     "null": null,
      //     "number": 21,
      //     "string": "Hi liquor-tree user!"
      // }
    };
  },

  computed: {},

  methods: {
    isString(value) {
      return "string" == typeof value;
    },

    isNaN(value) {
      return value !== value;
    },

    isBoolean(value) {
      return "boolean" == typeof value;
    },

    isNumber(value) {
      return "number" == typeof value;
    },

    isArray(value) {
      return Array.isArray(value);
    },

    isValue(value) {
      return !this.isArray(value) && !this.isPlainObject(value);
    },

    isPlainObject(value) {
      function isObject(obj) {
        return (
          obj != null && typeof obj === "object" && Array.isArray(obj) === false
        );
      }

      if (
        !isObject(value) ||
        !value.constructor ||
        !value.constructor.prototype
      ) {
        return false;
      }

      return (
        value.constructor.prototype.hasOwnProperty("isPrototypeOf") === true
      );
    },

    isIterable(value) {
      return this.isArray(value) || this.isPlainObject(value);
    },

    map(obj, fn) {
      return Object.keys(obj).map(key => {
        return fn(obj[key], key);
      });
    },

    transformObject(prop, key) {
      let obj = {
        text: key
      };

      if (this.isIterable(prop)) {
        obj.children = this.map(prop, this.transformObject);
        obj.data = {
          type: this.isArray(prop)
            ? "array"
            : this.isPlainObject(prop)
            ? "object"
            : "unknown"
        };
      } else {
        obj.data = {
          objectKey: prop || `${prop}`,
          type: this.getType(prop)
        };
      }

      return obj;
    },

    getType(value) {
      if (this.isNaN(value)) {
        return "viewer-type--nan";
      }

      if (this.isString(value)) {
        return "viewer-type--string";
      }

      if (this.isNumber(value)) {
        return "viewer-type--number";
      }

      if (this.isBoolean(value)) {
        return "viewer-type--boolean";
      }

      if (null === value) {
        return "viewer-type--null";
      }
    },

    parser(obj) {
      return [
        {
          text: "JSONObject",
          state: {
            expanded: true
          },
          data: {
            type: "root"
          },
          children: this.map(obj, this.transformObject)
        }
      ];
    }
  },

  mounted() {}
};
</script>

<liquor-json-viewer :json="json" />

<template>
  <div>
    <tree :data="treeData" :options="treeOptions">
      <span slot-scope="{ node }" class="viewer-item" :class="[node.data.type]">
        <span v-if="node.hasChildren()" class="viewer-item__key">
          {{ node.name }}
          <span v-if="node.collapsed()">
            <template v-if="node.data.type == 'array'">
              [ {{ node.children.length }} ]
            </template>
            <template v-else> { {{ node.children.length }} } </template>
          </span>
        </span>
        <span v-else class="viewer-item__prop">
          <span class="viewer-item__key">{{ node.name }}</span>
          :
          <span class="viewer-item__value">{{ node.data.objectKey }}</span>
        </span>
      </span>
    </tree>
  </div>
</template>

<style scoped></style>
